import React from "react";
import PropTypes from "prop-types";
import {connect, useDispatch} from "react-redux";
import {
  activeItemOfContentSelector,
  nameOfContentSelector,
  departmentOfContentSelector,
  changeOption as changeOptionAction,
  showPriceModal
} from "../../ducks/content";
import H from "../../../common/Typography/H";
import EditIcon from "../../../common/Icons/EditIcon";
import Options from "../../../common/Options";
import Price from "../../../common/Price";

import styles from "./bar.module.scss";
import {onPlatformSelector} from "../../ducks/onPlatform";
import GenericButton from "../../../common/GenericButton";

function Bar(props) {
  const {
    product: {
      title,
      editorPath,
      singular,
      options,
      condition: {
        options: currentOptions,
        price: {basePrice, currentPrice}
      }
    },
    category = 'root',
    department,
    onPlatform = 'printio'
  } = props;
  const dispatch = useDispatch()

  const changeOption = props.changeOption || ((value, name) => dispatch(changeOptionAction(value, name)))

  return (
    <div className={styles.root}>
      <H level={2} className={styles.title}>
        {title}
      </H>
      <div className={styles.editorButton}>
        <GenericButton
          size="large"
          vendorStyle={onPlatform}
          className={styles.button}
        >
          <a href={editorPath}>
            <EditIcon />
            Создать принт
          </a>
        </GenericButton>
      </div>
      <div className={styles.price}>
        <Price
          basePrice={basePrice}
          currentPrice={currentPrice}
          buttonAction={props.showPriceModal}
          buttonText="?"
          around
        />
      </div>
      <div className={styles.options}>
        <Options
          compact={true}
          productName={singular}
          department={department}
          category={category}
          options={options}
          currentOptions={currentOptions}
          changeOption={changeOption}
          vendorStyle={onPlatform}
        />
      </div>
    </div>
  );
}

Bar.propTypes = {
  product: PropTypes.object,
  category: PropTypes.string,
  department: PropTypes.string,
  changeOption: PropTypes.func,
  showPriceModal: PropTypes.func,
  onPlatform: PropTypes.string
};

const mapStateToProps = (state) => ({
  product: activeItemOfContentSelector(state),
  category: nameOfContentSelector(state),
  department: departmentOfContentSelector(state),
  onPlatform: onPlatformSelector(state)
});

export default connect(null, {showPriceModal})(Bar);
